export enum Routes {
    ROOT = "/",
    HOME = "/home",
    INBOX = "/inbox",
    SIGN_IN = "/sign-in",
    FORGOT_PASSWORD = "/forgot-password",
}
